import BaseChallengeAwardedPlaceService from 'services/challenge/awardedPlace/BaseChallengeAwardedPlaceService';

import ChallengeSubmissionAwardedPlace from 'models/challenge/awardedPlace/ChallengeSubmissionAwardedPlace';

export default class ChallengeSubmissionAwardedPlaceService extends BaseChallengeAwardedPlaceService {
	toModel(awardedPlace) {
		return new ChallengeSubmissionAwardedPlace(super.toModel(awardedPlace));
	}
}
